import script from "./panierRow.vue?vue&type=script&setup=true&lang=js"
export * from "./panierRow.vue?vue&type=script&setup=true&lang=js"

import "./panierRow.vue?vue&type=style&index=0&id=f59adf88&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f59adf88"]])

export default __exports__